import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop, uniqueId } from 'lodash';
import { reset, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Modal } from '@unite-us/app-components';
import EditButton from 'common/display/Profile/components/EditButton';
import './EditModal.scss';

export class ModalEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      submitDisabled: false,
      submitting: false,
    };

    // The footer Submit button is rendered outside the child <form>,
    // so it is linked to it through the HTML `form` attribute.
    this.formId = uniqueId('modal-edit-form-');

    this.onCancel = this.onCancel.bind(this);
    this.onSubmitStateChange = this.onSubmitStateChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
  }

  onCancel() {
    this.setState({ modalIsOpen: false });
    this.documentDialog.closeModal('cancel');
  }

  onSubmitStateChange({ submitting, submitDisabled }) {
    if (submitting !== this.state.submitting || submitDisabled !== this.state.submitDisabled) {
      this.setState({ submitting, submitDisabled });
    }
  }

  openDialog() {
    this.setState({ modalIsOpen: true });
    this.documentDialog.openModal();
  }

  render() {
    const {
      buttonId,
      cancelButtonId,
      children,
      disabled,
      header,
      id,
      labelText,
      removeCloseIcon,
      showEdit,
      size,
      submitButtonId,
    } = this.props;
    const { modalIsOpen, submitDisabled, submitting } = this.state;

    const childrenWithFuncs = React.Children.map(children, (child) => (
      React.cloneElement(child, {
        closeModal: this.onCancel,
        formId: this.formId,
        modalIsOpen,
        onSubmitStateChange: this.onSubmitStateChange,
      })
    ));

    return (
      <div className="edit-modal">
        {
          showEdit && (
            <EditButton
              disabled={disabled}
              edit={this.openDialog}
              id={buttonId}
              labelText={labelText}
              aria-label={buttonId.replace(/-/g, ' ').replace('btn', '').trim()}
            />
          )
        }
        <Modal
          id={id}
          title={header}
          removeCloseIcon={removeCloseIcon}
          size={size}
          modal
          showBorderRadius
          ref={(el) => { this.documentDialog = el; }}
          onRequestClose={() => {
            if (this.state.submitting) return;
            this.onCancel();
          }}
          actions={modalIsOpen ? (
            <div>
              <span className="mr-4 inline-block">
                <Button
                  id={cancelButtonId}
                  label="Cancel"
                  onClick={this.onCancel}
                  disabled={submitting}
                />
              </span>
              <span className="inline-block">
                <Button
                  id={submitButtonId}
                  type="submit"
                  form={this.formId}
                  label="Submit"
                  primary
                  disabled={submitDisabled}
                />
              </span>
            </div>
          ) : null}
        >
          {childrenWithFuncs}
        </Modal>
      </div>
    );
  }
}

ModalEditForm.propTypes = {
  buttonId: PropTypes.string.isRequired,
  cancelButtonId: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  removeCloseIcon: PropTypes.bool,
  showEdit: PropTypes.bool.isRequired,
  size: PropTypes.string,
  submitButtonId: PropTypes.string.isRequired,
  labelText: PropTypes.string,
};

ModalEditForm.defaultProps = {
  clearCurrentSelectedId: noop,
  dialogContentStyles: {},
  disabled: false,
  fields: [],
  initialValues: {},
  labelText: 'Edit',
  modalOpenCallback: noop,
  showEdit: true,
  removeCloseIcon: false,
};

export default connect(undefined, { reset, initialize })(ModalEditForm);
